import { render } from "./UserCreateView.vue?vue&type=template&id=d3fb4222"
import script from "./UserCreateView.vue?vue&type=script&lang=js"
export * from "./UserCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__